<template>
  <b-modal
    id="modal-flag-add"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    title="ADD FLAG"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <ValidationObserver
        ref="updateMerchantForm"
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          class="my-8"
          @submit.prevent="handleSubmit(onClickSetFlag)"
        >
          <b-row>
            <b-col
              md="8"
              xs="12"
            >
              <b-form-group
                label="Action"
                label-for="h-name"
                label-cols-lg="3"
                label-cols-xs="12"
              >
                <v-select
                  v-model="selectedFlag"
                  :options="flagOptions"
                  :reduce="option => option"
                  label="name"
                  placeholder="Select the Action"
                  :disabled="isDisabled"
                >
                  <template
                    v-slot:option="option"
                  >
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              xs="12"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="ml-1"
              >
                Get Operation
              </b-button>
            </b-col>
          </b-row>

        </b-form>
      </ValidationObserver>
      <hr>
      <b-row class="mb-2">
        <b-col
          md="12"
        >
          <div v-if="action === 0">
            <SetPickupRequest
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
            />
          </div>
          <div v-if="action === 1">
            <SetUrgent
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
            />
          </div>
          <div v-if="action === 2">
            <SetExchange
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
            />
          </div>
          <div v-if="action === 3">
            <SetReturn
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
            />
          </div>
          <div v-if="action === 4">
            <SetFutureRequest
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
            />
          </div>
          <div v-if="action === 5">
            <SetFragile
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
            />
          </div>
          <div v-if="action === 6">
            <SetRedelivery
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
            />
          </div>
          <div v-if="action === 7">
            <SetCustomFlag
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
              :flag-type="(selectedFlag && selectedFlag.type) ? selectedFlag.type : (form && form.length ? form[0].type : '')"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-alert
            variant="warning"
            :show="form.length === 0"
          >
            <h4 class="alert-heading">
              No Flags Have Been Set For This Order!!
            </h4>
          </b-alert>
        </b-col>
      </b-row>
      <div
        v-for="flag in form"
        :key="flag.key"
      >
        <b-list-group>
          <div
            v-if="flag.type === 'flag_1'"
          >
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-info"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="TruckIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>A Pickup Request has been placed to be picked up on <b>{{ flag.pivot.data.pickup_at }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 1"
                ><span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_2'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-danger"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="AlertOctagonIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Urgent Request have been placed</span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length !== 0"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_3'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-primary"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="RepeatIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Exchange Request has been placed with Original Waybill <b>{{ flag.pivot.data.original_waybill_number }}</b> and Exchange to Waybill <b>{{ flag.pivot.data.exchange_waybill_number }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 2"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_4'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-dark"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="ArrowLeftIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>A Return Request has been placed to Original Waybill <b>{{ flag.pivot.data.original_waybill_number }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 1"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_5'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-success"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="ClockIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>A Future Request has been placed to be delivered on <b>{{ flag.pivot.data.future_delivery_date }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 1"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_6'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-warning"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="UmbrellaIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Fragile Request have been placed</span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length !== 0"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_8'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-avatar
                  size="25"
                  variant="light-info"
                >
                  <feather-icon
                    icon="RotateCwIcon"
                    size="14"
                    class="text-body align-middle"
                  />
                </b-avatar>
              </span>
              <table>
                <tr><span>The redelivery request has been added to this order by <b>({{ flag.pivot.data.merchant_name }})</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length !== 0"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data.other_data && flag.pivot.data.other_data.remark ? flag.pivot.data.other_data.remark : 'N/A' }}</b></span>
                </tr>
              </table>
            </b-list-group-item>
          </div>
          <div v-if="flag.type === 'flag_9'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-primary"
                  pill
                  class="oms-badge"
                  size="32"
                >
                  <feather-icon
                    icon="CloudIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>This order put into the system by Storemate OMS</span></tr>
              </table>
            </b-list-group-item>
          </div>
          <div v-if="flag.is_system === false">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  :variant="getCustomVariant(flag)"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    :icon="getCustomIcon(flag)"
                    size="32"
                  />
                </b-badge>
              </span>

              <table>
                <tr>
                  <span>
                    A {{ flag.name }} Request has been placed
                  </span>
                </tr>

                <tr v-if="flag.pivot && flag.pivot.data">
                  <span class="remark-content">
                    Remark:
                    <b>{{ flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b>
                  </span>
                </tr>
              </table>
            </b-list-group-item>
          </div>
        </b-list-group>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BCol,
  BAvatar,
  BFormGroup,
  BForm,
  BRow,
  BBadge,
  BListGroup,
  BListGroupItem,
  BAlert,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import SetPickupRequest from '@/components/orders/SetPickupRequest.vue'
import SetUrgent from '@/components/orders/SetUrgent.vue'
import SetExchange from '@/components/orders/SetExchange.vue'
import SetReturn from '@/components/orders/SetReturn.vue'
import SetFutureRequest from '@/components/orders/SetFutureRequest.vue'
import SetFragile from '@/components/orders/SetFragile.vue'
import SetRedelivery from '@/components/orders/SetRedelivery.vue'
import SetCustomFlag from '@/components/orders/SetCustomFlag.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const OrderRepository = RepositoryFactory.get('order')
const FlagRepository = RepositoryFactory.get('flag')

function initialState() {
  return {
    open: false,
    isDisabled: false,
    modalLoading: false,
    loading: false,
    wayBill: null,
    id: null,
    statusKey: null,
    selectedFlag: null,
    action: null,
    form: {},
    refreshParent: null,
    flagOptions: [],
    customIconPool: [
      { icon: 'StarIcon', variant: 'light-primary' },
      { icon: 'TagIcon', variant: 'light-success' },
      { icon: 'GiftIcon', variant: 'light-info' },
      { icon: 'ZapIcon', variant: 'light-warning' },
      { icon: 'BookmarkIcon', variant: 'light-dark' },
      { icon: 'CompassIcon', variant: 'light-danger' },
    ],
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    SetFragile,
    SetReturn,
    SetExchange,
    SetUrgent,
    SetPickupRequest,
    SetFutureRequest,
    SetRedelivery,
    SetCustomFlag,
    BButton,
    BModal,
    BCol,
    BFormGroup,
    BForm,
    BAvatar,
    BRow,
    BBadge,
    BListGroup,
    BListGroupItem,
    BAlert,
    BOverlay,
    vSelect,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  methods: {
    async openModal(wayBill, statusKey, id) {
      Object.assign(this.$data, initialState())
      this.open = true
      this.wayBill = wayBill
      this.id = id
      this.statusKey = statusKey
      this.fetchFlagDetailsById()
      this.filterFlagOptions()
      this.refreshParent = this.$parent.onClickRefresh
    },
    async onClickSetFlag() {
      const flagObj = (this.selectedFlag && typeof this.selectedFlag === 'object')
        ? this.selectedFlag
        : this.flagOptions.find(f => f.name === this.selectedFlag)

      if (!flagObj || !flagObj.id) {
        this.showErrorMessage('Please Select an Action')
        return false
      }

      switch (flagObj.name) {
        case 'Pickup Request':
          this.action = 0
          return true
        case 'Urgent':
          this.action = 1
          return true
        case 'Exchange':
          this.action = 2
          return true
        case 'Return':
          this.action = 3
          return true
        case 'Future Delivery':
          this.action = 4
          return true
        case 'Fragile':
          this.action = 5
          return true
        case 'Redelivery':
          this.action = 6
          return true
        default:
          return this.applyCustomFlag(flagObj)
      }
    },
    async filterFlagOptions() {
      if (this.statusKey === 'key_3') {
        this.setNoActionsFound()
        return
      }

      const res = (await OrderRepository.getFlagDropdownByStatus(this.statusKey))
      const flagData = res.data.data

      if (!flagData.length) {
        this.setNoActionsFound()
        return
      }

      if (this.statusKey === 'key_17' || this.statusKey === 'key_18' || this.statusKey === 'key_19') {
        const shouldReturn = await this.handleRedeliveryFlags(flagData)
        if (shouldReturn) {
          return
        }
      }
      this.flagOptions = flagData
    },
    async handleRedeliveryFlags(flagData) {
      const redeliveryFlag = flagData.find(flag => flag.name === 'Redelivery')
      if (!redeliveryFlag) return false

      const maxAttempt = await this.fetchRedeliveryFlagDetails(redeliveryFlag.id)
      const response = await OrderRepository.getAssignedRedeliveryFlagCount(this.id)
      this.redeliveryFlagsData = response.data.data
      this.redeliveryFlagsCount = this.redeliveryFlagsData.redelivery_flag_count

      if (maxAttempt !== -1 && this.redeliveryFlagsCount >= maxAttempt) {
        this.setDeliveryAttemptExceed()
        return true // Indicates that an early exit should occur
      }
      return false // Indicates to continue
    },
    async fetchRedeliveryFlagDetails(redeliveryFlagId) {
      try {
        const { data } = (await FlagRepository.fetchFlagDetails(redeliveryFlagId)).data
        const maxAttemptMerchant = data.max_attempt_merchant
        return maxAttemptMerchant
      } catch (e) {
        this.convertAndNotifyError(e)
        return -1
      }
    },
    setNoActionsFound() {
      this.flagOptions = [
        { id: 0, name: 'No Actions Found for this Status' },
      ]
      this.isDisabled = true
      this.selectedFlag = 'No Actions Found for this Status'
    },
    setDeliveryAttemptExceed() {
      this.flagOptions = [{ id: 0, name: 'Maximum redelivery attempts reached.' }]
      this.isDisabled = true
      this.selectedFlag = 'Maximum redelivery attempts reached.'
    },
    async fetchFlagDetailsById() {
      try {
        this.modalLoading = true
        const { data } = (await OrderRepository.getOrderFlagDetailsById(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    setOpen(val) {
      this.open = val
    },
    async applyCustomFlag(flag) {
      if (!flag || !flag.id) {
        this.showErrorMessage('Invalid flag selected')
        return false
      }
      this.modalLoading = true
      try {
        this.action = 7
        return true
      } catch (e) {
        this.convertAndNotifyError(e)
        return false
      } finally {
        this.modalLoading = false
      }
    },
    getCustomIcon(flag) {
      const pool = this.customIconPool
      const index = flag.id ? Number(flag.id % pool.length) : flag.name.charCodeAt(0) % pool.length
      return pool[index].icon
    },
    getCustomVariant(flag) {
      const pool = this.customIconPool
      const index = flag.id ? Number(flag.id % pool.length) : flag.name.charCodeAt(0) % pool.length
      return pool[index].variant
    },
  },
}
</script>
<style lang="scss">
.remark-content{
    word-break: break-all;
  }
.oms-badge svg {
  height: 1rem !important;
  width: 1rem !important;
}
</style>
